import { mapGetters } from 'vuex';

import currentContactMixin from './currentContactMixin';

export default {
  mixins: [currentContactMixin],
  computed: {
    ...mapGetters({ currentUser: 'getCurrentUser' }),
    userHasPersonalWhatsappButtonAccess() {
      return this.currentUser.personal_whatsapp_button_access === true;
    },
    personalWhatsappButtonShouldBeVisible() {
      return (
        this.currentContact.phone_number &&
        this.userHasPersonalWhatsappButtonAccess
      );
    },
  },
};
